export const taskDate = {
  DEFAULT_FORMAT: 'DD-MM-YYYY HH:mm:ss'
}

export const DEFAULT_PROJECT_NAME = 'Быстрые задачи';
export const DEFAULT_SECTION_NAME = 'Основной раздел';
